import { useState, useEffect } from "react";
import { StaffMember } from "../types/productTypes";
import api from "../../../../../features/auth/axiosConfig";

export const useStaff = () => {
  const [staff, setStaff] = useState<StaffMember[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchStaff = async () => {
    setLoading(true);

    try {
      const response = await api.get("/app/v1/pos/staff?include_deleted=false");
      setStaff(response.data.result);
    } catch (error) {
      console.error("Error fetching staff:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const refetchStaff = () => {
    fetchStaff();
  };

  return { staff, loading, refetchStaff };
};
